import { combineReducers } from "redux";
import UserReducer from "./reducers/UserReducer";
import LoginUserReducer from "./reducers/LoginUserReducer";

export const MainReducer = combineReducers({
    UserReducer: UserReducer,
    LoginUserReducer: LoginUserReducer
})